import { latestNews } from "@/mocks/gossip";
import Reveal from "./Reveal";

export default function LatestSection() {
  return (
    <section id="latest" className="bg-background-100 py-16 md:py-24">
      <div className="section-wrap grid grid-cols-1 gap-10 lg:grid-cols-2">
        {/* latest stream */}
        <Reveal>
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-700">
              <span className="h-px w-6 bg-primary-600"></span> LATEST UPDATE
            </p>
            <h2 className="font-serif-editorial mt-3 text-3xl font-black text-foreground-950">
              最新动态
            </h2>
            <p className="mt-3 text-foreground-600">编辑部刚刚更新的瓜讯与追踪进展</p>
          </div>
          <div className="mt-7 flex flex-col gap-3">
            {latestNews.map((n, i) => (
              <Reveal key={n.id} delay={i * 50}>
                <a
                  href="#archive"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById("archive");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                    <i className="ri-flashlight-line"></i>
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="text-xs font-medium text-primary-700">{n.cat}</span>
                      <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
                      <span className="text-xs text-foreground-400">{n.time}</span>
                    </div>
                    <p className="mt-1 truncate text-[15px] font-medium text-foreground-900 group-hover:text-primary-700">
                      {n.title}
                    </p>
                  </div>
                  <span className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-400">
                    <i className="ri-eye-line"></i> {n.views}
                  </span>
                </a>
              </Reveal>
            ))}
          </div>
        </Reveal>

        {/* 吃瓜方法 tip card */}
        <Reveal delay={80}>
          <div className="flex h-full flex-col justify-center rounded-3xl bg-primary-900 p-8 text-primary-50 md:p-10">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-accent-500 text-xl text-white">
              <i className="ri-lightbulb-flash-line"></i>
            </span>
            <h3 className="font-serif-editorial mt-6 text-2xl font-black text-white md:text-3xl">
              吃瓜也要有「方法论」
            </h3>
            <p className="mt-4 leading-8 text-primary-100">
              一个热点事件，往往信息混杂、反转不断。真正的「来龙去脉」，不是追更碎片，
              而是看清事件的结构：谁在说话、证据链如何、时间线有没有被剪断。
            </p>
            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {[
                { t: "信源交叉验证", d: "不轻信单一账号" },
                { t: "关注关键节点", d: "抓反转与回应" },
                { t: "区分事实与情绪", d: "保持独立判断" },
                { t: "还原完整证据链", d: "警惕断章取义" },
              ].map((it) => (
                <li key={it.t} className="rounded-2xl bg-primary-800/70 px-4 py-3">
                  <p className="flex items-center gap-2 font-medium text-white">
                    <i className="ri-checkbox-circle-fill text-accent-400"></i>
                    {it.t}
                  </p>
                  <p className="mt-1 text-xs text-primary-200">{it.d}</p>
                </li>
              ))}
            </ul>
            <a
              href="#guide"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById("guide");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-7 inline-flex items-center gap-2 self-start whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-accent-600"
            >
              查看吃瓜指南 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}